import React, { useState } from "react";
import { Link } from 'react-router-dom'; // Make sure you have react-router-dom installed
import './css/Footer.css';
import logoDark from '../images/logo-dark.png';
import logoLight from '../images/logo-light.png';
import LogoMain from '../images/logo.png'


const Footer = ({ isDarkMode }) => {
  const logo = isDarkMode ? logoDark : logoLight;
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false); // Loading state

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading animation
    setMessage("");

    try {
      const response = await fetch("https://peracause.com/backend-files/per-a-cause/newsletter-per-a-cause.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `email=${encodeURIComponent(email)}`,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const text = await response.text();
      console.log("Raw Response:", text);

      try {
        const data = JSON.parse(text);
        console.log("Parsed JSON:", data);
        setMessage(data.message);
        if (data.status === "success") setEmail("");
      } catch (jsonError) {
        console.error("JSON Parsing Error:", jsonError);
        setMessage("Unexpected response format.");
      }
    } catch (error) {
      console.error("Network Error:", error);
      setMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false); // Stop loading animation
    }
  };



  return (
    <div className="">
      {/* Pre-footer section */}
      <section className="pre-footer container-fluid d-flex align-items-center justify-content-center py-5 position-relative">
        <div className="container">
          <h4 className="mb-3 title fw-bold fs-4 letter-spacing-3 text-center">LET'S COLLABORATE</h4>
          <h1 className="text-center letter-spacing-3">LET'S WORK TOGETHER</h1>
        </div>

        {/* Round button */}
        <div className="section-btn-conteiner position-absolute">
          <Link className="section-btn-content" to="/contact">
            <span className="section-btn-title text-white">Get Started</span>
            <span className="section-icon-arrow">
              <svg
                width="45px"
                height="43px"
                viewBox="0 0 66 43"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* SVG paths remain same */}
                <g id="arrow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <path
                    id="arrow-icon-one"
                    d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    id="arrow-icon-two"
                    d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                    fill="#FFFFFF"
                  ></path>
                </g>
              </svg>
            </span>
          </Link>
        </div>
      </section>

      {/* Main footer */}
      <footer className={`container-fluid ${isDarkMode ? "dark-footer" : "light-footer"}`}>
        <div className="container">
          <div className="row py-5">
            {/* Column 1 */}
            <div className="col-lg-4 col-md-8 my-2">
              {/* <img className="mb-2 footer-logo" src={logo} alt="Company Logo" /> */}
              <img className="mb-2 footer-logo" src={LogoMain} alt="Company Logo" />
              <p>
                Web Developers and Digital Marketers, Building powerful websites and driving impactful online
                growth
              </p>
              <ul className="social-media-links list-unstyled d-flex">
                <li className="me-3">
                  <a className="d-flex align-items-center justify-content-center rounded-circle text-decoration-none"
                    href="https://www.facebook.com/peracause"
                    target="_blank"
                    rel="noopener noreferrer">
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                </li>
                <li className="me-3">
                  <a className="d-flex align-items-center justify-content-center rounded-circle text-decoration-none"
                    href="https://wa.me/+919949047099"
                    target="_blank"
                    rel="noopener noreferrer">
                    <i class="fa-brands fa-whatsapp"></i>
                  </a>
                </li>
                <li className="me-3">
                  <a className="d-flex align-items-center justify-content-center rounded-circle text-decoration-none"
                    href="https://www.instagram.com/per_a_cause/"
                    target="_blank"
                    rel="noopener noreferrer">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </li>
                <li className="me-3">
                  <a className="d-flex align-items-center justify-content-center rounded-circle text-decoration-none"
                    href="https://x.com/peracause"
                    target="_blank"
                    rel="noopener noreferrer">
                    <i className="fa-brands fa-x-twitter"></i>
                  </a>
                </li>
                <li className="me-3">
                  <a className="d-flex align-items-center justify-content-center rounded-circle text-decoration-none"
                    href="https://www.linkedin.com/in/per-a-cause/"
                    target="_blank"
                    rel="noopener noreferrer">
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a>
                </li>
                <li className="me-3">
                  <a className="d-flex align-items-center justify-content-center rounded-circle text-decoration-none"
                    href="https://in.pinterest.com/peracause/"
                    target="_blank"
                    rel="noopener noreferrer">
                    <i class="fa-brands fa-pinterest"></i>
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 2 */}
            <div className="col-lg-2 col-md-4 col-6 my-2">
              <h2 className="mb-3 fs-3">Quick Links</h2>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <Link to="/" className="text-decoration-none text-white">Home</Link>
                </li>
                <li className="mb-2">
                  <Link to="/about" className="text-decoration-none text-white">About Us</Link>
                </li>
                <li className="mb-2">
                  <Link to="/services" className="text-decoration-none text-white">Services</Link>
                </li>
                <li className="mb-2">
                  <Link to="/blogs" className="text-decoration-none text-white">Blogs</Link>
                </li>
                <li className="mb-2">
                  <Link to="/contact" className="text-decoration-none text-white">Contact Us</Link>
                </li>
              </ul>
            </div>

            {/* Column 3 */}
            <div className="col-lg-2 col-md-4 col-6 my-2">
              <h2 className="mb-3 fs-3">Services</h2>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <Link to="/services/web-design" className="text-decoration-none text-white">Digital Marketing</Link>
                </li>
                <li className="mb-2">
                  <Link to="/services/web-design" className="text-decoration-none text-white">Web Designing</Link>
                </li>
                <li className="mb-2">
                  <Link to="/services/web-development" className="text-decoration-none text-white">Web Development</Link>
                </li>
                <li className="mb-2">
                  <Link to="/services/logo-creation" className="text-decoration-none text-white">Logo Designing</Link>
                </li>
                <li className="mb-2">
                  <Link to="/services/social-media" className="text-decoration-none text-white">SEO</Link>
                </li>
              </ul>
            </div>

            {/* Column 4 */}
            <div className="col-lg-4 col-md-8 my-2">
              <h2 className="mb-3 fs-3">Get In Touch</h2>
              <div className="mb-3">
                <a href="tel:+919949047099" className="d-flex align-items-center get-in-touch-point text-decoration-none mb-3">
                  <i className="fa-solid fa-phone point d-flex align-items-center justify-content-center rounded-circle me-3"></i>
                  <h3 className="m-0 title fs-5">+91 99490 47099</h3>
                </a>

                <a href="mailto:info@peracause.com" className="d-flex align-items-center get-in-touch-point text-decoration-none">
                  <i className="fa-solid fa-envelope point d-flex align-items-center justify-content-center rounded-circle me-3"></i>
                  <h3 className="m-0 title fs-5">info@peracause.com</h3>
                </a>
              </div>

              <h3 className="mb-3">Subscribe Our Newsletter</h3>
              <div className="input-wrapper rounded-4 d-flex">
                <form onSubmit={handleSubmit} className="d-flex rounded-2 w-100">
                  <input
                    placeholder="Enter your Email"
                    className="input text-white rounded-2 flex-grow-1"
                    name="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit" className="Subscribe-btn text-white rounded-2 px-3">
                    Subscribe
                  </button>
                  
                  
                </form>
                {/* Loading animation */}
                {loading && (
                  <div className="loading-spinner">
                    <div className="spinner"></div>
                    {/* <p>Sending Email...</p> */}
                  </div>
                )}
                {message && <p>{message}</p>}
                
              </div>
            </div>
          </div>

          <div className="copyright-line py-4">
            <p className="text-center m-0">
              Copyright &copy; 2025 <strong>Per A Cause</strong>. All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;